/** The toast stack. Entries retire themselves; this only renders them. */

import { type Component, For } from 'solid-js';
import { toasts } from '../../state/ui.ts';
import styles from './Toasts.module.css';

export const Toasts: Component = () => (
  <div class={styles.toasts} aria-live="polite">
    <For each={toasts()}>{(entry) => <div class={styles.toast}>{entry.message}</div>}</For>
  </div>
);
